
import fetchExpected from './fetchExpected'
import fetchReal from './fetchReal'

export default {
  fetchExpected,
  fetchReal
}



// WEBPACK FOOTER //
// ./src/services/customersExtranet/index.js